export enum CommunicationMethodMagicLink {
  Manual = 'manual',
  Email = 'email',
  Sms = 'sms',
  Whatsapp = 'whatsapp',
  Rcs = 'rcs',
}

export const TEXT_MESSAGE_COMMUNICATION_METHODS = [CommunicationMethodMagicLink.Sms, CommunicationMethodMagicLink.Rcs];
